import { render, staticRenderFns } from "./CounterText.vue?vue&type=template&id=c5b9ac0c&scoped=true&"
import script from "./CounterText.vue?vue&type=script&lang=js&"
export * from "./CounterText.vue?vue&type=script&lang=js&"
import style0 from "./CounterText.vue?vue&type=style&index=0&id=c5b9ac0c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b9ac0c",
  null
  
)

export default component.exports